import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommuneModel } from 'src/models/commune.model';

@Injectable({
  providedIn: 'root'
})
export class CommmuneService {
  private communesSubject: BehaviorSubject<Array<CommuneModel>>;
  public communes$: Observable<Array<CommuneModel>>;

  constructor(private http: HttpClient) {
    this.communesSubject = new BehaviorSubject<Array<CommuneModel>>([]);
    this.communes$ = this.communesSubject.asObservable();
  }

  public get value(): Array<CommuneModel> {
    return this.communesSubject.value;
  }

  update(communes: Array<CommuneModel>){
    this.communesSubject.next(communes);
  }

  list(): Observable<any> {
    return this.http.get(`${environment.apiUrl}communes/`) as Observable<any>;
  }


  getCommunesByPrefecture(pk: number) {
    return this.http.post(`${environment.apiUrl}communes/get_communes_by_pref/`, {prefecture: pk}) as Observable<any>;
  }
}
